import {Suspense, useEffect, useState} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { RecoilRoot, useRecoilState } from 'recoil';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { bodyOpacityTransitionAtom } from './store';
import { ErrorPage } from './components/ErrorPage';
import * as Sentry from "@sentry/react";
import { checkMobile, IGNORE_MESSAGES } from './utils/format';
import 'intersection-observer';
import './i18n';
import { MicroAppStart } from "./utils/qiankun";
import { isPrerenderUserAgent } from "./utils/hooks";
import { makeFetchTransport, makeMultiplexedTransport } from "@sentry/react";
import {globalErrorHandler} from "./utils/globalErrorHandler";

const root = ReactDOM.createRoot(document.getElementById('root'));
const isSentryEnabled = (window._env_.REACT_APP_ENABLE_SENTRY === 'true') && !isPrerenderUserAgent()
const EXTRA_KEY = "ROUTE_TO";

const transport = makeMultiplexedTransport(makeFetchTransport, (args) => {
    const event = args.getEvent(['event', 'transaction', 'replay_event'])
    if (
        event &&
        event.extra &&
        EXTRA_KEY in event.extra &&
        Array.isArray(event.extra[EXTRA_KEY])
    ) {
        return event.extra[EXTRA_KEY];
    }
    return [];
});

Sentry.init({
    dsn: "https://767ae4e4acd8fc7fa444acf2c68ea14e@sentry.deemos.com/4",
    transport,
    integrations: [
        Sentry.moduleMetadataIntegration(),
        Sentry.browserTracingIntegration(),
        Sentry.browserProfilingIntegration(),
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
            networkDetailAllowUrls: [window.location.origin],
            networkRequestHeaders: ["Cache-Control"],
            networkResponseHeaders: ["Referrer-Policy"],
            networkCaptureBodies: true,
        }),
    ],
    tracesSampleRate: localStorage.getItem('user_uuid') ? 1.0 : 0.1,
    profilesSampleRate: localStorage.getItem('user_uuid') ? 1.0 : 0.1,
    replaysSessionSampleRate: localStorage.getItem('user_uuid') ? 0.1 : 0.1,
    replaysOnErrorSampleRate: localStorage.getItem('user_uuid') ? 1.0 : 0.1,
    environment: (process.env.REACT_APP_ENV && process.env.NODE_ENV) ? process.env.REACT_APP_ENV : process.env.NODE_ENV,
    enabled: isSentryEnabled,
    ignoreErrors: IGNORE_MESSAGES,
    beforeSend: (event) => {
        if (event?.exception?.values?.[0]?.stacktrace?.frames) {
            const frames = event.exception.values[0].stacktrace.frames;
            // Find the last frame with module metadata containing a DSN
            const routeTo = frames
                .filter(
                    (frame) => frame.module_metadata && frame.module_metadata.dsn,
                )
                .map((v) => v.module_metadata)
                .slice(-1);
            if (routeTo.length) {
                event.extra = {
                    ...event.extra,
                    [EXTRA_KEY]: routeTo,
                };
            }
        }

        return event;
    },
});

MicroAppStart()

const Fallback = <ErrorPage />;

function Outter() {
    const [bodyOpacityTransition, setBodyOpacityTransition] = useRecoilState(bodyOpacityTransitionAtom,);
    const [isMobile, setIsMobile] = useState(null);

    // useEffect(() => {
    //     console.info("/  _ \\/  __//  __// \\__/|/  _ \\/ ___\\\n" +
    //         "| | \\||  \\  |  \\  | |\\/||| / \\||    \\\n" +
    //         "| |_/||  /_ |  /_ | |  ||| \\_/|\\___ |\n" +
    //         "\\____/\\____\\\\____\\\\_/  \\|\\____/\\____/\n" +
    //         "                                     ")
    //     console.info(
    //         `%cPioneering 3D Generative AI\n%cGet in touch for career opportunities: hello@deemos.com`,
    //         "color: white; font-size: 10px; font-weight: bold;",
    //         "color: white; font-size: 10px;"
    //     );
    // }, []);

        // init fortix rc
    //     window.__DEEMOS_FORTIX_RC__.init({
    //         appid: "1792659904"
    //     })

    //     // check mobile status
    //     setIsMobile(checkMobile());

    //     window.addEventListener('error', globalErrorHandler, true);
    //     window.addEventListener('unhandledrejection', globalErrorHandler, true);

    //     // remove loading status
    //     const loadingElement = document.getElementById('index-loading');
    //     if (loadingElement) {
    //         loadingElement.parentNode.removeChild(loadingElement);
    //     }
    // }, []);

    useEffect(() => {
        if (bodyOpacityTransition) {
            document.body.style.opacity = 0;
            setTimeout(() => {
                setBodyOpacityTransition(false);
            }, 500);
        } else {
            document.body.style.opacity = 1;
        }
    }, [bodyOpacityTransition]);

    return (
        <Router basename={process.env.REACT_APP_ROUTER_BASENAME ? process.env.REACT_APP_ROUTER_BASENAME : '/'}>
            <App isMobile={isMobile} />
        </Router>
    );
}

root.render(
    <Sentry.ErrorBoundary
        fallback={({ error, resetError }) => (
            <ErrorPage
                errorMessage={error?.message}
                resetError={resetError}
            />
        )}>
        <Suspense fallback={''}>
            <RecoilRoot>
                <Outter />
            </RecoilRoot>
        </Suspense>
    </Sentry.ErrorBoundary>
);
